/**
 * @generated SignedSource<<5c0815c0107c1b5d6a00cc9ce8ad1c91>>
 * @relayHash 313625b5fcb3c3c18f05806d494cb9d2
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/441.0.0-2023-12-07T14:38:11.118Z/PdpSharedShoppingButton_userCartItemAddMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserCartItemAddInput = {
  clientMutationId?: string | null;
  itemId: string;
  quantity: string;
  skuId: string;
};
export type PdpSharedShoppingButton_userCartItemAddMutation$variables = {
  input: UserCartItemAddInput;
};
export type PdpSharedShoppingButton_userCartItemAddMutation$data = {
  readonly userCartItemAdd: {
    readonly clientMutationId: string | null;
  } | null;
};
export type PdpSharedShoppingButton_userCartItemAddMutation = {
  response: PdpSharedShoppingButton_userCartItemAddMutation$data;
  variables: PdpSharedShoppingButton_userCartItemAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserCartItemAddPayload",
    "kind": "LinkedField",
    "name": "userCartItemAdd",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PdpSharedShoppingButton_userCartItemAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PdpSharedShoppingButton_userCartItemAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-finding/441.0.0-2023-12-07T14:38:11.118Z/PdpSharedShoppingButton_userCartItemAddMutation",
    "metadata": {},
    "name": "PdpSharedShoppingButton_userCartItemAddMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "9c324b137ce4361ae7f4cc03d4663ae8";

export default node;
